<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Lịch sử hoạt động</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <Select2
              v-model="search.creatorUser"
              :options="dataManager"
              placeholder="Người thực hiện"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              data-toggle="tooltip"
              data-placement="top"
              title="Mã ticket, Danh mục công việc, Sản phẩm, Mã tham chiếu, Mã khách hàng, Tên khách hàng, Số điện thoại, Email, Tên người đại diện, Mã workflow"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.groupCode"
              @change="getListTicketCategory()"
              :options="Config.getSearch(dataGroupCode)"
              placeholder="Nhóm ticket"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeCode"
              @change="fetchDataCurrentState()"
              :options="Config.getSearch(dataTypeCode)"
              placeholder="Danh mục ticket"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.subTypeCode"
              :options="Config.getSearch(dataSubTypeCode)"
              placeholder="Tiểu mục ticket"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.currentStateCode"
              :options="Config.getSearch(dataCurrentState)"
              placeholder="Hiện trạng ticket"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionId"
              :options="dataConfigRegion"
              placeholder="Vùng kinh doanh"
            />
          </div>
          <div class="form-group">
            <input type="hidden" class="form-control text-left" v-model="merchantSelected" />
            <input
              type="text"
              class="form-control text-left"
              :value="merchantSelected.merchantName ? `${merchantSelected.merchantName}` : ''"
              placeholder="Merchant"
              v-b-modal.select-merchant-dialog
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.receiverUser"
              :options="dataManager"
              placeholder="Người tiếp nhận"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.supervisorUser"
              :options="Config.getSearch(optionsUserSupervisor)"
              placeholder="Người giám sát"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.createdTime"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian thực hiện
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.workingUnit"
              :options="Config.getSearch(dataDepartment)"
              placeholder="Bộ phận đang xử lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.workPriority"
              :options="Config.getSearch(dataPriority)"
              placeholder="Mức ưu tiên"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.workType"
              :options="Config.getSearch(dataWorkType)"
              placeholder="Loại công việc"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.workingStepTime"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời hạn bước hiện tại
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.ticketDeadline"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời hạn ticket
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(creatorUser)="data">
                <p>{{ data.item.creatorName }}</p>
                <p>{{ data.item.createAt | formatDate('HH:mm, DD/MM/YYYY') }}</p>
              </template>
              <template #cell(activity)="data">
                <p v-if="data.item.actionValue">Phân loại: {{ data.item.actionValue }}</p>
                <p v-if="data.item.currentStateCode === 'OTHER'">
                  Hiện trạng: Khác ({{ data.item.currentState }})
                </p>
                <p v-else>Hiện trạng: {{ data.item.currentState }}</p>
                <p v-if="data.item.actionResult">Kết quả: {{ data.item.actionResult }}</p>
                <p class="c-pointer" v-if="data.item.link" @click="link(data.item.link)">
                  <u>Chi tiết</u>
                </p>
              </template>
              <template #cell(ticket)="data">
                <p
                  class="c-pointer"
                  v-if="data.item.ticketCode"
                  @click="detail(data.item.ticketId)"
                >
                  <u>{{ data.item.ticketCode }}</u>
                </p>
                <p><b>Tham chiếu:</b>{{ data.item.referenceId }}</p>
              </template>
              <template #cell(classify)="data">
                <p v-if="data.item.groupCodeText"><b>Nhóm:</b> {{ data.item.groupCodeText }}</p>
                <p v-if="data.item.typeCodeText"><b>Danh mục:</b> {{ data.item.typeCodeText }}</p>
                <p v-if="data.item.subTypeCodeText">
                  <b>Tiểu mục:</b> {{ data.item.subTypeCodeText }}
                </p>
              </template>
              <template #cell(merchant)="data">
                <div v-if="data.item.merchantInfo">
                  <p><b>Tên:</b> {{ data.item.merchantInfo.merchantName }}</p>
                  <p><b>Email:</b> {{ data.item.merchantInfo.email }}</p>
                  <p><b>Điểm bán:</b> {{ data.item.mcBizAddress ? data.item.mcBizAddress : '' }}</p>
                  <p><b>Sale phụ trách:</b> {{ data.item.saleEmail ? data.item.saleEmail : '' }}</p>
                </div>
              </template>
              <template #cell(assignee)="data">
                <div>
                  <p v-if="!!data.item.receiverUser">
                    <b>Tiếp nhận:</b> {{ data.item.receiverUser.name }}
                  </p>
                  <p v-if="!!data.item.supervisorUser">
                    <b>Giám sát:</b> {{ data.item.supervisorUser.name }}
                  </p>
                </div>
              </template>
              <template #cell(infoManage)="data">
                <p><b>Đang xử lý:</b> {{ data.item.workingUnitText }}</p>
                <p><b>Ưu tiên:</b> {{ data.item.workPriorityText }}</p>
                <p><b>Loại công việc:</b> {{ data.item.workTypeText }}</p>
              </template>
              <template #cell(deadlineTime)="data">
                <p>
                  <b>Bước hiện tại:</b>
                  {{ data.item.workingStepTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p>
                  <b>Ticket:</b> {{ data.item.ticketDeadline | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(time)="data">
                <p>
                  <b>Tạo ticket:</b>
                  {{ data.item.ticketCreateAt | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p>
                  <b>Hoàn thành:</b>
                  {{ data.item.ticketCompleteAt | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p><b>Huỷ:</b> {{ data.item.ticketCancelAt | formatDate('HH:mm, DD/MM/YYYY') }}</p>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="detail(data.item.ticketId)" class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.pageIndex"
            @change="onChangePage"
            :total-rows="pagination.total"
            :per-page="search.pageSize"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <SelectMerchant @selectMerchant="onSelectMerchant" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import { TicketService } from '@/services/ticket.service'
  import moment from 'moment'
  import cloneDeep from 'lodash/cloneDeep'
  import SelectMerchant from '@/components/SelectMerchant.vue'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'creatorUser', label: 'Người thực hiện', thStyle: 'min-width: 170px' },
    { key: 'activity', label: 'Hoạt động', thStyle: 'min-width: 170px' },
    { key: 'ticket', label: 'Ticket', thStyle: 'min-width: 170px' },
    { key: 'classify', label: 'Phân loại', thStyle: 'min-width: 170px' },
    { key: 'merchant', label: 'Merchant', thStyle: 'min-width: 170px' },
    { key: 'assignee', label: 'Người', thStyle: 'min-width: 190px' },
    { key: 'infoManage', label: 'TT Quản lý', thStyle: 'min-width: 190px' },
    { key: 'deadlineTime', label: 'Thời hạn', thStyle: 'min-width: 190px' },
    { key: 'time', label: 'Thời gian', thStyle: 'min-width: 190px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'ticket-work',
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataManager: [],
        dataTypeCode: [],
        dataGroupCode: [],
        dataConfigRegion: [],
        search: {
          pageSize: 20,
          pageIndex: 1,
          createdTime: {},
          workingStepTime: {},
          ticketDeadline: {},
        },
        pagination: {
          total: 0,
        },
        merchantSelected: {},
        optionsUserSupervisor: [],
        dataSubTypeCode: [],
        dataDepartment: [],
        dataWorkType: [],
        dataPriority: [],
        dataCurrentState: [],
      }
    },
    components: { SelectMerchant },
    watch: {},
    created() {
      TicketService.fetchGroup()
        .then(s => s.data?.map(s => ({ id: s.code, text: s.name, mapId: s.id })) ?? [])
        .then(s => (this.dataGroupCode = s))
      StaffService.getStaffByIdSuperior({ userId: this.dataUser.userId })
        .then(s => s.data?.map(s => ({ id: s.userId, text: `${s.name} - ${s.userName}` })) ?? [])
        .then(s => (this.dataManager = s))
      StaffService.getRegions()
        .then(s => s.data?.map(s => ({ id: s.id, text: s.name })) ?? [])
        .then(s => (this.dataConfigRegion = s))
      TicketService.getListDepartment()
        .then(s => s.data.data)
        .then(s => Object.keys(s).map(key => ({ id: key, text: s[key] })))
        .then(s => (this.dataDepartment = s))
      TicketService.getListWorkType()
        .then(s => s.data.data)
        .then(s => Object.keys(s).map(key => ({ id: key, text: s[key] })))
        .then(s => (this.dataWorkType = s))
      TicketService.getListPriority()
        .then(s => s.data.data)
        .then(s => Object.keys(s).map(key => ({ id: key, text: s[key] })))
        .then(s => (this.dataPriority = s))
      this.fetchData()
      this.fetchUserSupervisor()
      this.getListTicketCategory()
      this.getListTicketSubCategory()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      preareData() {
        const data = cloneDeep(this.search)
        for (const key in data) {
          if (data[key] === '0') delete data[key]
        }
        if (data.createdTime.endDate) {
          data.createFrom = moment(data.createdTime.startDate).startOf('day').valueOf()
          data.createTo = moment(data.createdTime.endDate).endOf('day').valueOf()
        }
        if (data.workingStepTime.endDate) {
          data.workingStepTimeFrom = moment(data.workingStepTime.startDate).startOf('day').valueOf()
          data.workingStepTimeTo = moment(data.workingStepTime.endDate).endOf('day').valueOf()
        }
        if (data.ticketDeadline.endDate) {
          data.ticketDeadlineFrom = moment(data.ticketDeadline.startDate).startOf('day').valueOf()
          data.ticketDeadlineTo = moment(data.ticketDeadline.endDate).endOf('day').valueOf()
        }

        delete data.workingStepTime
        delete data.ticketDeadline
        delete data.createdTime
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const { pageIndex, pageSize, ...filterData } = params
          const result = {
            filterData: {
              ...filterData,
            },
            pageIndex,
            pageSize,
          }
          const response = await TicketService.fetchHistory(result)
          if (response.code === 1000) {
            this.lists = response.data
            this.pagination.total = response.meta.total
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      async fetchDataCurrentState() {
        try {
          // this.showLoading = true
          let params = {}
          if (this.search.typeCode) {
            params = { applyFor: [this.search.typeCode] }
          }
          const response = await TicketService.fetchCurrentStateTicket(params)
          if (response.code === 1000) {
            this.dataCurrentState = response.data.map(s => ({ id: s.code, text: s.name })) ?? []
            this.getListTicketSubCategory()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          // this.showLoading = false
          this.selectedTicket = []
        }
      },
      async removeForm() {
        this.search = {
          pageSize: 20,
          pageIndex: 1,
          createdTime: {
            startDate: null,
            endDate: null,
          },
          workingStepTime: {
            startDate: null,
            endDate: null,
          },
          ticketDeadline: {
            startDate: null,
            endDate: null,
          },
        }
        this.merchantSelected = {}
        await this.fetchData()
        await this.getListTicketCategory()
        await this.getListTicketSubCategory()
      },
      async submitForm() {
        this.search.pageIndex = 1
        this.fetchData()
      },
      onSelectMerchant(mc) {
        this.search.merchantId = mc ? mc.customerId : ''
        this.merchantSelected = mc || {}
      },
      detail(id) {
        const routeData = this.$router.resolve({ path: `/ticket/${id}` })
        window.open(routeData.href, '_blank')
      },
      link(link) {
        window.open(link, '_blank')
      },
      async fetchUserSupervisor() {
        try {
          this.showLoading = true
          const params = {
            typeSales: [
              'SALE_DIRECTOR',
              'OPERATOR_SYSTEM',
              'REGION_DIRECTOR',
              'SALE_ADMIN',
              'SALE_MANAGER',
              'SALE_LEADER',
              'AFTER_SALE_LEADER',
              'TELESALE_LEADER',
              'TRAINER_LEADER',
              'MARKETING',
            ],
          }
          const response = await TicketService.getUserSupervisor(params)
          this.optionsUserSupervisor = response.data.map(item => ({
            id: item.id,
            text: `${item.name} - ${item.email}`,
          }))
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async getListTicketCategory() {
        try {
          let findGroup = {}
          this.dataTypeCode = []
          if (this.search.groupCode && this.search.groupCode != '') {
            findGroup = this.dataGroupCode.find(s => s.id === this.search.groupCode)
          }

          const params = {
            groupId: Object.keys(findGroup).length > 0 && findGroup.mapId ? findGroup.mapId : '',
          }

          const res = await TicketService.getListTicketCategory(params)
          if (res.code === 1000) {
            this.dataTypeCode = res.data.map(e => {
              return { id: e.code, text: e.name, mapId: e.id }
            })
          }
        } catch (error) {}
      },
      async getListTicketSubCategory() {
        try {
          let findType = {}
          this.dataSubTypeCode = []
          if (this.search.typeCode && this.search.typeCode != '') {
            findType = this.dataTypeCode.find(s => s.id === this.search.typeCode)
          }

          const params = {
            categoryId: Object.keys(findType).length > 0 && findType.mapId ? findType.mapId : '',
          }

          const res = await TicketService.getListTicketSubCategory(params)
          if (res.code === 1000) {
            this.dataSubTypeCode = res.data.map(e => {
              return { id: e.code, text: e.name, mapId: e.id }
            })
          }
        } catch (error) {}
      },
      onChangePage(page) {
        this.search.pageIndex = page
        this.fetchData()
      },
    },
  }
</script>
<style scoped>
  .c-pointer {
    cursor: pointer;
  }
</style>
